import * as actions from "Actions";
import * as api from "Api";

export const fetchClientsList = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const {
      label,
      budgetState,
      budgetWarning
    } = getState().clients.list.filter;
    const { paginationPage, pageSize } = getState().clients.list;
    const { year } = getState().clients.list;

    const {
      collaborator,
      squads,
      cluster,
      entityClientId: { selected, statusBudgetEco, isEntity, deletedStatus }
    } = getState().clients.filter;

    const {
      filter: { clientCRMGroup, clientCRMTypes }
    } = getState().financialSheet.periodTree;

    return dispatch(
      actions.getClientsList(
        api.getClientsList(
          {
            id: currentOrganization.id,
            paginationPage,
            pageSize,
            label,
            budgetState,
            year,
            budgetWarning
          },
          collaborator.selected,
          collaborator.role,
          squads.selected,
          cluster.selected,
          selected,
          statusBudgetEco,
          isEntity,
          deletedStatus,
          clientCRMGroup,
          clientCRMTypes
        )
      )
    );
  };
};

export const fetchBudgetYears = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;

    return dispatch(
      actions.getBudgetYears(api.getBudgetYears(currentOrganization.id))
    );
  };
};

export const saveClientEntitySetting = (
  clientId,
  year,
  isEntityClient,
  entityClientId
) => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.saveClientEntitySetting(
      api.saveClientEntitySetting({
        organization: currentOrganization.id,
        clientId,
        isEntityClient,
        entityClientId,
        year
      })
    )
  );
};

export const importClientsBudget = () => {
  return (dispatch, getState) => {
    const {
      importAttachment,
      importedYear
    } = getState().clients.importClientsBudget;
    const { currentOrganization } = getState().auth;
    return dispatch(
      actions.importClientsBudget(
        api.importClientsBudget({
          importAttachment,
          data: currentOrganization.id,
          importedYear
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/client.js